import {
  Card,
  Group,
  LoadingOverlay,
  SimpleGrid,
  Text,
  Title,
  useMantineTheme,
} from '@mantine/core';
import { useFetch } from '@mantine/hooks';
import { useAuthUser } from '../../../providers/AuthProvider';

interface Session {
  id: string;
  patient_id: string;
}

export function AppStats() {
  const user = useAuthUser();
  const userId = user?.id;
  const theme = useMantineTheme();

  const { data, loading } = useFetch<{ data: Session[] }>(
    userId
      ? `${import.meta.env.VITE_API_URL}/services/configurations?user_id=${userId}`
      : '',
    {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  const sessionCount = data?.data?.length ?? 0;

  const uniquePatientIds = new Set(
    data?.data?.map(item => item.patient_id) ?? []
  );
  const uniquePatientCount = uniquePatientIds.size;

  return (
    <Card shadow='sm' withBorder p='sm' radius='sm'>
      <Title order={4} mb='sm'>
        Utilizzo app
      </Title>
      <SimpleGrid cols={2}>
        <Card shadow='sm' p='sm' radius='sm' bg='gray.1'>
          <Group>
            <LoadingOverlay visible={loading} />
            <Text fw={700} c={theme.primaryColor} size='30px'>
              {uniquePatientCount}
            </Text>
            <Text>Utenti censiti</Text>
          </Group>
        </Card>
        <Card shadow='sm' p='sm' radius='sm' bg='gray.1'>
          <Group>
            <LoadingOverlay visible={loading} />
            <Text fw={700} c={theme.primaryColor} size='30px'>
              {sessionCount}
            </Text>
            <Text>Sessioni</Text>
          </Group>
        </Card>
      </SimpleGrid>
    </Card>
  );
}
